// Generated from b2bservices/src/common/productRequirements/base.ts.
// Do not edit. Run yarn requirements:sync in a paired checkout.

import { isNewFood, isWhiteSnus } from './categories';
import { getRequiredNutritionalFields, hasNutritionalValue, isBlank, hasTemperatureValue, REQUIRED_NUTRITIONAL_FIELDS } from './validators';
import type { CategoryNode, ProductFieldRule, ProductValues } from './types';

/** Fields owned by native base/conditional completeness, including currently inactive groups. */
export const BASE_REQUIREMENT_FIELDS = ['title', 'EAN', 'descriptive_size_amount', 'descriptive_size_unit', 'image_src',
  'non_food_ingredients', 'whiteSnusNicotinePerPortion', 'whiteSnusNicotinePerGram',
  ...REQUIRED_NUTRITIONAL_FIELDS, 'min_temperature', 'max_temperature', 'transportMinTemperature', 'transportMaxTemperature'];

export const getRequiredProductFields = (state?: ProductValues, rootCategory?: CategoryNode, categoryPath?: readonly string[]) => {
  const fields: { field: string; label: string; missing: boolean }[] = [];
  if (!state) return fields;
  if (isWhiteSnus(state.foodlaCategory, rootCategory, state, categoryPath)) fields.push(
    { field: 'non_food_ingredients', label: 'Innehållsförteckning', missing: isBlank(state.non_food_ingredients) },
    { field: 'whiteSnusNicotinePerPortion', label: 'Nikotin per portion', missing: isBlank(state.whiteSnusNicotinePerPortion) },
    { field: 'whiteSnusNicotinePerGram', label: 'Nikotin per gram', missing: isBlank(state.whiteSnusNicotinePerGram) },
  );
  fields.push(
    { field: 'title', label: 'Produktnamn', missing: isBlank(state.title) },
    { field: 'EAN', label: 'EAN-kod', missing: isBlank(state.EAN) },
    { field: 'descriptive_size_amount', label: 'Nettokvantitet Mängd', missing: state.descriptive_size_amount == null || state.descriptive_size_amount <= 0 },
    { field: 'descriptive_size_unit', label: 'Nettokvantitet Enhet', missing: isBlank(state.descriptive_size_unit) },
  );
  return fields;
};

/** Completeness is independent of the caller's draft/submission save policy. */
export const baseProductRules = (state: ProductValues, rootCategory?: CategoryNode, categoryPath?: readonly string[], imageCount?: number): ProductFieldRule[] => {
  const fields = getRequiredProductFields(state, rootCategory, categoryPath);
  const rules: ProductFieldRule[] = fields.map(({ field, label, missing }) => ({
    fields: [field], label, organizations: 'base', requireValidator: () => !missing,
  }));
  rules.push({ fields: ['image_src'], label: 'Produktbild för e-handel', organizations: 'base',
    requireValidator: () => imageCount == null
      ? !isBlank(state.image_src) || (Array.isArray(state.additionalImages) && state.additionalImages.some(image => !isBlank(image)))
      : imageCount > 0 });
  if (isNewFood(state.foodlaCategory, rootCategory, state, categoryPath)) {
    const nutrition = getRequiredNutritionalFields(state);
    if (nutrition.length) rules.push({ fields: nutrition, label: 'Näringsdeklaration', organizations: 'base',
      requireValidator: ({ field }) => hasNutritionalValue(state[field]) });
  }
  if (!state.producerIsStore) for (const [minimum, maximum] of [
    ['min_temperature', 'max_temperature'], ['transportMinTemperature', 'transportMaxTemperature'],
  ]) {
    if (hasTemperatureValue(state[minimum]) || hasTemperatureValue(state[maximum])) rules.push({
      fields: [minimum, maximum], label: 'Temperaturuppgifter', organizations: 'base',
      requireValidator: ({ field }) => hasTemperatureValue(state[field]),
    });
  }
  return rules;
};
